export class ValueMapping {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "ValueMappingType",
            "format": ""
        },
        {
            "name": "match",
            "baseName": "match",
            "type": "string",
            "format": ""
        },
        {
            "name": "_from",
            "baseName": "from",
            "type": "number",
            "format": "double"
        },
        {
            "name": "to",
            "baseName": "to",
            "type": "number",
            "format": "double"
        },
        {
            "name": "result",
            "baseName": "result",
            "type": "ValueMappingResult",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ValueMapping.attributeTypeMap;
    }
    constructor() {
    }
}
